import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const CopyRight = () => {
  const homeData = useSelector((e) => e?.states.homePageData);
  return (
    <div className="footer-bottom">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer-bottom-wrapper">
              <div className="footer-bottom-links">
                <ul>
                  <li>
                    <Link to="/disclaimer">Disclaimer</Link>
                    <Link to="/terms-of-use">Terms of Use</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>

                    <Link to="/payment-policy">Payment Policy</Link>
                  </li>
                </ul>
                <p>
                  ©2025, Unipath Specialty laboratory Ltd. All rights reserved
                </p>
              </div>
              <div className="footer-bottom-logo">
                {homeData?.affiliations?.map((item) => (
                  <span >
                    <img alt="" src={item?.image} />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyRight;
